import { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { setCookie, getCookie } from '../../utils'

export const TemporaryBanner = ({ id, text }) => {
  const isHidden = getCookie(id)
  const [isShown, setShown] = useState(!isHidden)

  const onClose = () => {
    setShown(false)
  }

  const onDontShowClick = () => {
    setShown(false)
    setCookie(id, true, { expires: 3600 * 24 * 30 })
  }

  if(!isShown) {
    return null
  }

  return (
    <div className='tip-banner'>
      <p className='tip-banner__text'>{text}</p>
      <button className='btn-borderless-blue' onClick={onDontShowClick}>
        <FormattedMessage
          id="don't_show_this_again"
          defaultMessage="Don't show me this again"
        />
      </button>
      <button className='btn-close btn-borderless-red' onClick={onClose}>
        x
      </button>
    </div>
  )
}

TemporaryBanner.propTypes = {
  id: PropTypes.string,
  text: PropTypes.any,
}
